import { ChannelCardProps } from '@/components/molecules/ChannelCard/ChannelCard';
import { RenderRTE } from '@/components/RenderRTE';

export const mapChannelCard = (channels: SiteChannel[], asW2?: boolean): [string[], ChannelCardProps[]] => {
    const channelIds: string[] = [];
    const channelCards: ChannelCardProps[] = [];

    channels.forEach((channel) => {
        channelIds.push(channel.fields.id);
        channelCards.push({
            radioImageUrl: channel.fields.color_logo?.url || '',
            radioImageAlt: channel.fields.color_logo?.altText || channel.fields.channel_name,
            radioImageHeight: 50,
            radioImageWidth: 104,
            title: channel.fields.display_name || channel.fields.name,
            subTitle: <RenderRTE contentfulDoc={channel.fields.short_description} removeSpanTag asW2={asW2} />,
            showAndScheduleLink: channel.fields?.shows_schedules_url?.href,
            showAndScheduleLinkText: channel.fields?.shows_schedules_url?.link_text,
            showsAndScheduleLinkAriaLabel: channel.fields?.shows_schedules_url?.aria_label,
            showAndScheduleLinkTarget: channel.fields?.shows_schedules_url?.link_target,
            listenLink: channel.fields.deep_link_to_player || 'https://player.siriusxm.com',
            listenLinkAriaLabel: `Listen live to ${channel.fields.channel_name}`,
            borderColor: channel.fields.primary_color || '',
            albumImageSrc: channel.fields.playing?.album.art || channel.fields.color_logo?.url || '',
            albumImageAlt: channel.fields.playing?.album.title || '',
            songTitle: channel.fields.playing?.content.title || '',
            songArtist: channel.fields.playing?.content.artist || '',
        });
    });

    return [channelIds, channelCards];
};

export const mapToChannelProps = (channels: SiteChannel[]): ChannelCardProps[] => {
    return channels.map((channel) => ({
        radioImageUrl: channel.fields.color_logo?.url || '',
        radioImageAlt: channel.fields.color_logo?.altText || channel.fields.channel_name,
        radioImageHeight: 50,
        radioImageWidth: 104,
        title: channel.fields.display_name || channel.fields.name,
        subTitle: <RenderRTE contentfulDoc={channel.fields.short_description} removeSpanTag />,
        showAndScheduleLink: channel.fields?.shows_schedules_url?.href,
        showAndScheduleLinkText: channel.fields?.shows_schedules_url?.link_text,
        showsAndScheduleLinkAriaLabel: channel.fields?.shows_schedules_url?.aria_label,
        showAndScheduleLinkTarget: channel.fields?.shows_schedules_url?.link_target,
        listenLink: channel.fields.deep_link_to_player || 'https://player.siriusxm.com',
        listenLinkAriaLabel: `Listen live to ${channel.fields.channel_name}`,
        borderColor: channel.fields.primary_color || '',
        albumImageSrc: channel.fields.playing?.album.art || channel.fields.color_logo?.url || '',
        albumImageAlt: channel.fields.playing?.album.title || '',
        songTitle: channel.fields.playing?.content.title || '',
        songArtist: channel.fields.playing?.content.artist || '',
    }));
};

export const getChannelIds = (channels: SiteChannel[]): string[] => {
    return channels.map((channel) => channel.fields.id);
};
